import { createResourceKeys } from "@/lib/resource-context";

export const sessionVerificationKeys = createResourceKeys(
  "session-verification"
);
